module.exports = __webpack_public_path__ + "fonts/Inter-400-greek-ext27.2329210.woff2";